export default {
  deliveryMethodHeader: "إعداد طريقة التوصيل",
  deliveryMethodContent: "اختر طريقة التوصيل الخاصة بك لتسليم الطلبات لعملائك.",
  restaurantHeader: "توصيل المطعم",
  restaurantContent: "سيقوم المطعم بإرسال الطلب إلى العميل",
  koinzHeader: "توصيل كوينز",
  koinzContent: "سيقوم مندوب كوينز بإرسال الطلب إلى العميل",
};
